import { render, staticRenderFns } from "./inventories.vue?vue&type=template&id=6f1dc064"
import script from "./inventories.vue?vue&type=script&lang=js"
export * from "./inventories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports